<template>
    <div class="table">
        <div :class="['topbar', { expanded: isExpanded }]">
            <div class="sales-information">
                <div class="switch">
                    <label class="switch-label">
                        <input type="checkbox" v-model="showBaths" />
                        <span class="slider round"></span>
                    </label>
                    <span class="switch-text">{{ showBaths ? $t('headerLabels.numberLabels') : $t('headerLabels.production') }}</span>
                </div>
            </div>

            <div class="content">
                <div class="navBar">
                    <button class="nav left" @click="scrollLeft"></button>

                    <div class="hours" ref="scrollContainer1">
                        <div v-for="(value, hour) in summary_hours" :key="hour" class="nav-elements">
                            <div
                                class="timeframe"
                                :class="{
                                    current: currentTimeframe == formatHour(hour, 'HH:mm')
                                }"
                            >
                                <span style="cursor: pointer" @click="printProductsByHour(hour)" class="title">{{ displayHour(hour) }}</span>
                            </div>
                        </div>
                    </div>
                    <button class="nav right" @click="scrollRight"></button>
                </div>
            </div>
        </div>
        <div class="content-sections hide-scrollbar" ref="scrollContainer4">
            <div class="product-content">
                <div class="products">
                    <div class="item" v-for="product in filteredProducts" :key="product.id">
                        <div class="icon" :style="{ backgroundImage: 'url(' + product.image + ')' }"></div>
                        <div class="content">
                            <div class="name">
                                {{ formatDisplayMeasurement(product.name) }}
                            </div>
                            <div class="container">{{ getProductContainerDisplay(product) }}</div>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div class="forecast">
                        <div class="item" v-for="product in filteredProducts" :key="product.id" ref="scrollContainer">
                            <span style="cursor: pointer" @click="printProduct(product.id, hour)" v-for="(value, hour) in summary_hours" :key="hour" class="value" :class="{ current: currentTimeframe == hour, null: productTotals[product.id][hour] == '-' }">
                                <template v-if="productTotals[product.id][hour]">
                                    <span class="value-units">{{ formatDisplayNumber(productTotals[product.id][hour].units) }}</span>
                                    <span v-if="productTotals[product.id][hour].deviation > 0" class="deviation" :class="productTotals[product.id][hour].deviantion_class">{{ formatDisplayNumber(productTotals[product.id][hour].deviation) }}</span>
                                </template>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { formatMeasurementLabel } from '@/utils/numberFormat'

import { formatDisplayTimeFromStore } from '@/utils/dateFormatters'
import { formatNumberLabel } from '@/utils/numberFormat'
import { isObject } from 'lodash'
import { indexOf } from 'lodash'

export default {
    name: 'temperingView',
    data() {
        return {
            isExpanded: false,
            start_hour: 0,
            max_hours: 4,
            showBaths: true
        }
    },
    props: {
        products: {
            type: Array
        },
        date: { type: String }
    },
    computed: {
        loggedUser() {
            return this.$store.getters['loginUser/getLocalEmployee']
        },
        schedule_oclock() {
            return true
        },
        forecast() {
            return this.$store.getters['production/getForecast']
        },
        productTotals() {
            const totals = {}
            this.filteredProducts.forEach((product) => {
                totals[product.id] = this.getTotal(product.id)
            })
            return totals
        },
        currentTimeframe() {
            let current_hour = false
            if (moment().isSame(this.date, 'day')) {
                for (let hour in this.summary_hours_complete) {
                    if (moment().format('HH') < parseInt(hour.split(' ')[1])) {
                        break
                    }
                    current_hour = hour.split(' ')[1]
                }

                return current_hour
            }
            return false
        },
        summary_hours() {
            var hours = {}
            let position = 0
            let inserted = 0
            if (Object.keys(this.forecast.products.tempering).length > 0) {
                for (var idx in Object.values(this.forecast.products.tempering)[0].hours) {
                    if (position >= this.start_hour && inserted < this.max_hours) {
                        
                        if (!this.schedule_oclock) {
                            hours[moment(idx).add(30, 'minutes').format('YYYY-MM-DD HH:mm')] = 0
                        } else {
                            hours[moment(idx).format('YYYY-MM-DD HH:mm')] = 0
                        }
                        inserted += 1
                    }
                    position += 1
                }
            }

            return hours
        },
        summary_hours_complete() {
            var hours = {}
            if (Object.keys(this.forecast.products.tempering).length > 0) {
                for (var idx in Object.values(this.forecast.products.tempering)[0].hours) {
                    if (!this.schedule_oclock) {
                        hours[moment(idx).add(30, 'minutes').format('YYYY-MM-DD HH:mm')] = 0
                    } else {
                        hours[moment(idx).format('YYYY-MM-DD HH:mm')] = 0
                    }
                }
            }
            return hours
        },
        filteredProducts() {
            return this.products.filter((product) => [3, 5, 7, 8].includes(product.type))
        }
    },
    methods: {
        formatDisplayMeasurement(value) {
            return formatMeasurementLabel(value, this.$i18n.locale, count => this.$tc('measurements.unit', count))
        },
        displayHour(hour) { return formatDisplayTimeFromStore(moment(hour)) },
        formatDisplayNumber(value, fractionDigits) {
            return formatNumberLabel(value, this.$i18n.locale, fractionDigits)
        },
        roundConditional(value, units) {
            const factor = value / units < 1 ? 0.1 : 0.25
            let roundedValue = Math.round(Math.ceil(value / units / factor) * factor * 100) / 100
            return this.showBaths ? Math.ceil(roundedValue) : roundedValue
        },
        formatHour(hour, format) {
            return moment(hour).format(format)
        },
        getTotal(productId) {
            var product = this.filteredProducts.find((item) => item.id === productId)
            var container = this.getProductContainer(product)
            if (!product || !container) {
                var emptyResult = {}
                for (var emptyIdx in this.summary_hours) {
                    emptyResult[this.formatHour(emptyIdx, 'HH:mm')] = {
                        units: '-',
                        deviation: '',
                        deviantion_class: ''
                    }
                }
                emptyResult.total = '-'
                return emptyResult
            }
            var units = container.units
            var factor = 0.25
            var result = {}
            if (this.forecast && this.forecast.products && typeof this.forecast.products.tempering[productId] !== 'undefined') {
                for (var idx in this.forecast.products.tempering[productId].hours) {
                    if (!this.schedule_oclock) {
                        var key = moment(idx).add(30, 'minutes').format('YYYY-MM-DD HH:mm')
                    } else {
                        var key = moment(idx).format('YYYY-MM-DD HH:mm')
                    }
                    factor = this.forecast.products.tempering[productId].hours[idx] / units < 1 ? 0.1 : 0.25
                    // console.warn('factor', factor, 'units', units, 'hours', this.forecast.products.tempering[productId].hours[idx])

                    var value = this.roundConditional(this.forecast.products.tempering[productId].hours[idx], units)

                    var deviation = 0
                    var deviantion_class = ''
                    if (this.forecast.pmix_real && this.forecast.pmix_real.tempering && this.forecast.pmix_real.tempering[productId] && this.forecast.pmix_real.tempering[productId].hours && this.forecast.pmix_real.tempering[productId].hours[idx]) {
                        if (isObject(this.forecast.pmix_real.tempering[productId].hours[idx])) {
                            var current_deviation = Math.floor(this.forecast.pmix_real.tempering[productId].hours[idx].i)
                            var currentvalue = Math.ceil(this.forecast.pmix_real.tempering[productId].hours[idx].v)
                            value = this.roundConditional(currentvalue, units)
                            deviation = this.roundConditional(current_deviation, units)
                        }

                        if (deviation > 0) {
                            deviantion_class = 'increase'
                        } else if (deviation < 0) {
                            deviantion_class = 'decrease'
                        }
                        deviation = Math.abs(deviation)
                    }

                    result[key] = {
                        units: value,
                        deviation: deviation,
                        deviantion_class: deviantion_class
                    }
                    if (result[key] == 0) {
                        result[key] = {
                            units: '-',
                            deviation: '',
                            deviantion_class: ''
                        }
                    }
                }
                result.total = this.roundConditional(this.forecast.products.tempering[productId].total, units)
                // round total to 2 decimals maximum
            } else {
                for (var idx in this.summary_hours) {
                    result[this.formatHour(idx, 'HH:mm')] = {
                        units: '-',
                        deviation: '',
                        deviantion_class: ''
                    }
                }
                result.total = '-'
            }

            return result
        },
        scrollLeft() {
            var value = this.start_hour - 1
            if (value < 0) {
                value = 0
            }
            this.start_hour = value
        },
        scrollRight() {
            var value = this.start_hour + 1
            var totalSlots = Object.keys(this.summary_hours_complete).length - 1;
            if (value + this.max_hours > totalSlots) {
                value = totalSlots - this.max_hours
            }
            this.start_hour = value
        },
        loadForecast() {
            let self = this
            this.$overlay.loading()
            this.$store.dispatch('production/loadForecast', this.date).then(() => {
                self.$overlay.hide()
            })
        },

        printProductsByHour(hour) {
            var self = this
            let references = []
            this.filteredProducts.forEach((product) => {
                let value = self.productTotals[product.id][hour] ? self.productTotals[product.id][hour].units : '-'
                value = value == '-' || value == '' ? 0 : value
                if (value > 0) {
                    var product_labels = self.calculateProductLabels(product.id, hour)
                    references.push(...product_labels)
                }
            })

            references = references.filter((item) => item.quantity > 0)
            if (!this.loggedUser) {
                self.$store.commit('loginUser/setRefreshLayout', false)
                this.$popup.login({
                    list: this.$store.getters['employee/getLoginUsers'](0),
                    callAfterAccess: function () {
                        this.$popup.close()
                        self.$store.commit('loginUser/setRefreshLayout', true)
                        this.$popup.confirm({
                            message: self.$t('production.temperingView.popup.print_hour.message', { hour }),
                            textSave: self.$t('label.popup.text_save'),
                            textCancel: self.$t('production.configuration.cancel'),
                            callSave: function () {
                                self.$store.dispatch('label/prepareTemporalCollection', references).then((response) => {
                                    log(response)
                                    let categories = { [response.id]: response }
                                    self.$store.dispatch('label/loadMultiplePrint', { categories: categories }).then(() => {
                                        self.$router.push({ name: 'Label', params: { print: true, type: 'collection', id: response.id, page: 'tempering' } })
                                    })
                                })
                            }
                        })
                    }
                })
            } else {
                this.$popup.confirm({
                    message: self.$t('production.temperingView.popup.print_hour.message', { hour }),
                    textSave: self.$t('label.popup.text_save'),
                    textCancel: self.$t('production.configuration.cancel'),
                    callSave: function () {
                        self.$store.dispatch('label/prepareTemporalCollection', references).then((response) => {
                            log(response)
                            let categories = { [response.id]: response }
                            self.$store.dispatch('label/loadMultiplePrint', { categories: categories }).then(() => {
                                self.$router.push({ name: 'Label', params: { print: true, type: 'collection', id: response.id, page: 'tempering' } })
                            })
                        })
                    }
                })
            }
        },

        parseContainerNameMeta(name) {
            const safeName = typeof name === 'string' ? name : ''
            let suffix = safeName.includes('gr)') ? 'gr' : 'ud'
            const suffixMatch = safeName.match(/\(\d+ (.*)\)/)
            if (suffixMatch) {
                suffix = suffixMatch[1]
            }

            let maxUnits = 1
            const decimalMatch = safeName.match(/\((\d+,\d+)/)
            if (decimalMatch) {
                maxUnits = Math.round(parseFloat(decimalMatch[1].replace(',', '.')) * 10) / 10
            } else {
                const intMatch = safeName.match(/\((\d+)/)
                if (intMatch) {
                    maxUnits = parseInt(intMatch[1], 10) || 1
                }
            }

            return { maxUnits, suffix }
        },
        calculateProductLabels(id, timeframe) {
            var product = this.filteredProducts.find((item) => item.id === id)
            var container = this.getProductContainer(product)
            if (!product || !container) {
                return []
            }

            var units = container.units
            const { maxUnits, suffix } = this.parseContainerNameMeta(container.name)
            const isDecimal = product.is_decimal == 1

            var max_units = 1
            var calc = units
            var format = suffix
            var transform = false
            if (container.label) {
                calc = container.label.calc
                format = container.label.units
                max_units = maxUnits
                transform = true
            }

            let references = []

            // if timeframe is total then we need the sum of morning and afternoon
            var value = this.forecast.products.tempering[id].hours[timeframe]
            if(this.forecast.pmix_real && this.forecast.pmix_real.tempering && this.forecast.pmix_real.tempering[id] && this.forecast.pmix_real.tempering[id].hours && this.forecast.pmix_real.tempering[id].hours[timeframe]) {
                value = this.forecast.pmix_real.tempering[id].hours[timeframe].v
            }

            if (value > 0) {
                let package_value = transform ? max_units : units 
                if(!isDecimal) {
                    package_value = Math.round(package_value);
                }
                package_value = parseFloat(package_value.toFixed(1));

                references.push({
                    id: product.id,
                    state_id: product.label_states.tempering,
                    quantity: Math.floor(value / max_units / calc),
                    package: package_value + format
                })
                var remaining = value % units

                function roundToNearest(value, x) {
                    let step = x / 10
                    let values = Array.from({ length: 10 }, (_, i) => step * (i + 1))
                    return values.reduce((prev, curr) => (Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev))
                }

                remaining = remaining > 0 ? roundToNearest(remaining, units) : 0;

                if (remaining > 0) {
                    package_value = transform ? (Math.round((remaining * max_units) / units) == 0 ? 1 : ((remaining * max_units) / units)) : (remaining)
                    package_value = parseFloat(package_value.toFixed(1));
                    if(!isDecimal) {
                        package_value = Math.round(package_value);
                    }
                    if(package_value > 0) {
                        references.push({
                            id: product.id,
                            state_id: product.label_states.tempering,
                            quantity: 1,
                            package: package_value + format
                        })
                    }
                }
            }

            // group references by package summing quantity
            const groupedReferences = references.reduce((acc, curr) => {
                const key = curr.package
                if (!acc[key]) {
                    acc[key] = { ...curr, quantity: 0 }
                }
                acc[key].quantity += curr.quantity
                return acc
            }, {})

            // remove references with quantity 0 to groupedReferences
            Object.keys(groupedReferences).forEach((key) => {
                if (groupedReferences[key].quantity === 0) {
                    delete groupedReferences[key]
                }
            })

            return Object.values(groupedReferences)
        },

        printProduct(id, timeframe) {
            var self = this
            var product = this.filteredProducts.find((item) => item.id === id)

            var references = this.calculateProductLabels(id, timeframe)

            var total_labels = references.reduce((acc, curr) => acc + curr.quantity, 0)

            if (total_labels > 0) {
                if (!this.loggedUser) {
                    self.$store.commit('loginUser/setRefreshLayout', false)
                    this.$popup.login({
                        list: this.$store.getters['employee/getLoginUsers'](0),
                        callAfterAccess: function () {
                            this.$popup.close()
                            self.$store.commit('loginUser/setRefreshLayout', true)
                            this.$popup.confirm({
                                message: self.$t('production.defrostView.popup.print_product.message', {
                                    count: total_labels,
                                    product: self.formatDisplayMeasurement(product.name)
                                }),
                                textSave: self.$t('label.popup.text_save'),
                                textCancel: self.$t('production.configuration.cancel'),
                                callSave: function () {
                                    self.$store.dispatch('label/prepareTemporalCollection', references).then((response) => {
                                        log(response)
                                        let categories = { [response.id]: response }
                                        self.$store.dispatch('label/loadMultiplePrint', { categories: categories }).then(() => {
                                            self.$router.push({ name: 'Label', params: { print: true, type: 'collection', id: response.id, page: 'tempering' } })
                                        })
                                    })
                                }
                            })
                        }
                    })
                } else {
                    this.$popup.confirm({
                        message: self.$t('production.defrostView.popup.print_product.message', {
                            count: total_labels,
                            product: self.formatDisplayMeasurement(product.name)
                        }),
                        textSave: self.$t('label.popup.text_save'),
                        textCancel: self.$t('production.configuration.cancel'),
                        callSave: function () {
                            self.$store.dispatch('label/prepareTemporalCollection', references).then((response) => {
                                log(response)
                                let categories = { [response.id]: response }
                                self.$store.dispatch('label/loadMultiplePrint', { categories: categories }).then(() => {
                                    self.$router.push({ name: 'Label', params: { print: true, type: 'collection', id: response.id, page: 'tempering' } })
                                })
                            })
                        }
                    })
                }
            }
        },
        getContainerName(name) {
            if (!name || typeof name !== 'string') return ''
            return this.formatDisplayMeasurement(name).trim()
        },
        getProductContainer(product) {
            if (!product || !product.containers) return null
            return product.containers[product.active_container] || Object.values(product.containers)[0] || null
        },
        getProductContainerDisplay(product) {
            var container = this.getProductContainer(product)
            return container ? this.getContainerName(container.name) : ''
        }
    },
    created() {
        var hour = this.currentTimeframe

        if (hour) {
            let date = Object.keys(this.summary_hours_complete)[0]
            hour = moment(date).format('YYYY-MM-DD') + ' ' + hour
            var day_offset = moment(this.date).format('YYYY-MM-DD') < moment(moment(date).format('YYYY-MM-DD')).unix() ? 1 : 0
            hour = moment(hour).add(day_offset, 'days').format('YYYY-MM-DD HH:mm')
            this.start_hour = indexOf(Object.keys(this.summary_hours_complete), hour) - 1
        }
    }
}
</script>
<style lang="scss" scoped>
.table {
    display: flex;
    flex-direction: column;
    height: 100%;

    .positive {
        font-family: $text-bold !important;
        color: $color-success-500;
    }
    .negative {
        font-family: $text-bold !important;
        color: $color-error-500;
    }

    .topbar {
        width: 100%;
        height: 10%;
        display: flex;
        align-items: center;
        overflow: hidden;

        .content {
            display: flex;
            width: calc(70% + 30px);
            justify-content: flex-end;
            overflow-x: auto;
        }

        button {
            height: 50px;
            width: 50px;
            font-size: 30px;
            background-color: #fff;
        }
        .sales-information {
            width: calc(30% - 30px);
            display: flex;
            flex-direction: row;
            justify-content: left;
            align-items: center;
            flex-shrink: 0;
            height: 50px;
            gap: 8px;

            .nav {
                border-radius: 4px;
                display: flex;
                align-self: flex-start;
                width: 50px;
                height: 50px;
                align-items: center;
                &.sales-button {
                    @include background($image: img('chart_inactive.svg'), $size: 20px, $color: #fff);
                }
                &.active {
                    &.sales-button {
                        @include background($image: img('chart_active.svg'), $size: 20px, $color: $main);
                    }
                }
                &.mail {
                    @include background($image: img('mail.svg'), $size: 25px, $color: #fff);
                }
            }
        }
        .navBar {
            width: calc(100% - 100px);
            display: flex;
            justify-items: start;
            grid-template-columns: repeat(3, 1fr);
            gap: 10px;

            .nav-elements {
                //width: 250px;
                @include display-flex();
                @include align-items();
                gap: 8px;
                width: 100%;

                &.total {
                    width: 125px;
                    align-items: center;
                    justify-content: center;
                }

                .printer {
                    border-radius: 4px;
                    display: flex;
                    align-self: flex-start;
                    width: 50px;
                    height: 50px;
                    align-items: center;
                    @include background($image: img('printer_b3b3b3.svg'), $size: 20px, $color: #fff);
                }
                .timeframe {
                    @include display-flex();
                    flex-direction: column;
                    align-items: center;
                    width: 100%;
                    padding: 4px 0;
                    border-radius: 4px;

                    &.current {
                        background: rgba($color-warning-500, 1);

                        .title {
                            color: #fff;
                        }
                        .subtitles {
                            .subtitle {
                                color: #fff;
                            }
                        }
                    }

                    .title {
                        text-transform: uppercase;
                        color: $color-black;
                        @include font-size(m);
                        font-family: $text-bold;
                    }

                    .description {
                        color: $color-neutral-600;
                        @include font-size(xs);
                        font-family: $text;
                        line-height: 14px;
                    }
                }
            }

            .nav {
                border-radius: 4px;
                width: 50px;
                height: 50px;

                &.left {
                    @include background($image: img('left_dark.svg'), $size: 20px, $color: #fff);
                }
                &.right {
                    @include background($image: img('right_dark.svg'), $size: 20px, $color: #fff);
                }
            }
            .hours {
                width: calc(100% - 100px);
                height: 50px;
                display: flex;
                flex-direction: row;
                align-items: flex-end;
                overflow-x: hidden;
                scroll-behavior: smooth;
                gap: 10px;
                padding: 0 0px;

                display: grid;
                justify-items: start;
                grid-template-columns: repeat(4, 1fr);
                align-items: center;
                justify-items: center;

                .scroll-item {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex: 0 0 80px;
                    height: 100%;
                    width: 100px;
                    max-width: 100px;
                    min-width: 100px;
                    margin-left: 5px;

                    p {
                        font-family: $text;
                        font-size: 20px;
                        color: $color-neutral-600;
                    }
                }
                & .selected {
                    border: 2px solid $color-warning-500;
                    p {
                        font-family: $text-bold;
                    }
                }
            }
        }
        .summary-title {
            text-align: center;
            width: 125px;
            flex-shrink: 0;

            span {
                word-wrap: break-word;
                @include font-size(m);
                color: $color-neutral-600;
                font-family: $text-bold;
                text-transform: uppercase;
            }
        }
    }
    .content-sections {
        height: 90%;
        overflow: auto;
        .sales-section {
            width: 100%;
            display: flex;
            flex-direction: row;
            .sales-text {
                width: 30%;
                padding-left: 40px;
                span {
                    display: block;
                    font-family: $text;
                    display: flex;
                    align-items: center;
                    height: 35px;
                }
            }
            .sales-content {
                width: 70%;
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                box-sizing: border-box;
                overflow: hidden;
                .sales-forecast {
                    width: calc(100% - 100px);
                    display: grid;
                    flex-direction: column;
                    grid-template-rows: repeat(4, 1fr);
                    align-items: center;
                    overflow-x: hidden;
                    overflow-y: hidden;
                    scroll-behavior: smooth;

                    .row {
                        display: grid;
                        flex-direction: row;
                        gap: 25px;
                        width: 100%;
                        grid-template-columns: repeat(3, 1fr);
                        text-align: center;

                        span {
                            text-align: center;
                        }

                        .scroll-item {
                            flex: 0 0 80px;
                            height: 35px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 100px;
                            max-width: 100px;
                            min-width: 100px;
                            margin-left: 5px;

                            span {
                                text-align: center;
                                width: 100px;
                                font-family: $text;

                                &.positive {
                                    font-family: $text-bold;
                                    color: $color-success-500;
                                }
                                &.negative {
                                    font-family: $text-bold;
                                    color: $color-error-500;
                                }
                            }
                        }
                    }
                }
            }
            .sales-summary {
                width: 125px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                flex-shrink: 0;
                span {
                    font-family: $text;
                    display: flex;
                    align-items: center;
                    height: 35px;
                }
            }
        }
        .product-content {
            display: flex;
            flex-direction: row;
            width: 100%;
            margin-top: 16px;

            .products {
                width: 30%;
                display: flex;
                flex-direction: column;
                gap: 10px;

                .item {
                    width: 100%;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    &:hover {
                        background-color: rgba(255, 255, 255, 0.6);
                    }
                    &.frost {
                        &:hover {
                            background-color: $main-t90;
                        }
                    }

                    .icon {
                        width: 35px;
                        height: 35px;
                        background-repeat: no-repeat;
                        background-position: center;
                        background-size: 90%;
                        display: inline-block;
                    }
                    .content {
                        flex-direction: column;
                        width: 100%;
                        padding-left: 8px;
                        .name {
                            display: flex;
                            align-items: center;
                            font-family: $text-bold;
                            text-transform: none; // Preserve the case of SI symbols in product names.
                            @include font-size(sm);
                        }
                        .icon {
                            /* background-image: img('/img/defrost.svg'); */
                            height: 25px;
                            width: 25px;
                        }
                        .container {
                            display: block;
                            font-family: $text;
                            color: $color-neutral-600;
                            display: block;
                        }
                    }
                }
            }

            .content {
                display: flex;
                width: 70%;
                justify-content: flex-end;

                .forecast {
                    width: calc(100% - 190px);
                    margin-right: 60px;
                    display: flex;
                    flex-direction: column;
                    align-content: center;
                    align-items: stretch;
                    flex-direction: column;
                    gap: 10px;

                    .item {
                        height: 50px;
                        display: grid;
                        grid-template-columns: repeat(4, 1fr);
                        flex-direction: row;
                        align-items: center;
                        overflow-x: hidden;
                        scroll-behavior: smooth;
                        padding: 0;
                        gap: 5px;
                        width: 100%;

                        .value {
                            font-family: $text;
                            @include font-size(m);
                            display: block;
                            height: 45px;
                            background: #fff;
                            border: 2px solid #ddd;
                            border-radius: 3px;
                            @include display-flex();
                            @include align-items();
                            @include justify-content();
                            position: relative;
                            flex-direction: column;
                            //width: 250px;

                            &.total {
                                font-family: $text-bold;
                                margin-left: 10px;
                            }
                            &.started {
                                // background-color: $color-error-500;
                                border-color: $color-error-500;
                                font-family: $text-bold;
                                color: $color-error-500;
                            }
                            &.completed {
                                border-color: $color-success-500;
                                // color: $color-success-500;
                                // font-family: $text-bold;
                            }
                            &.null {
                                border-color: #ddd;
                                font-family: $text;
                            }

                            .increase {
                                display: block;
                                position: absolute;
                                bottom: 0px;
                                @include font-size(xs);
                                display: flex;
                                align-items: center;

                                &:before {
                                    display: inline-block;
                                    content: '';
                                    width: 0;
                                    height: 0;
                                    border-left: 5px solid transparent;
                                    border-right: 5px solid transparent;
                                    border-radius: 3px;
                                    margin-right: 2px;
                                }

                                &.positive {
                                    &:before {
                                        border-bottom: 6px solid green;
                                    }
                                }
                                &.negative {
                                    &:before {
                                        border-top: 6px solid #f00;
                                    }
                                }
                            }

                            &.current {
                                // background-color: $color-warning-500;
                                // border-color: $color-warning-500;
                                // font-family: $text-bold;
                                // color: #fff;

                                .value {
                                    color: #fff;
                                }
                                .increase {
                                    color: #fff;
                                }
                            }

                            .value-units {
                                display: block;
                            }

                            .deviation {
                                @include font-size(s);
                                display: block;
                                margin-top: -5px;
                                margin-bottom: -5px;
                                &:before {
                                    // triangle 5px
                                    width: 0;
                                    height: 0;
                                    content: ' ';
                                    margin-right: 2px;
                                    border-radius: 5px;
                                    display: inline-block;
                                }
                                &.increase {
                                    color: $color-success-500;
                                    &:before {
                                        border-bottom: 5px solid $color-success-500;
                                        border-left: 5px solid transparent;
                                        border-right: 5px solid transparent;
                                    }
                                }
                                &.decrease {
                                    color: $color-error-500;
                                    &:before {
                                        border-top: 5px solid $color-error-500;
                                        border-left: 5px solid transparent;
                                        border-right: 5px solid transparent;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .summary {
                width: 125px;
                text-align: center;
                .item {
                    width: 100%;
                    height: 75px;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;

                    .value {
                        font-family: $text-bold;
                        @include font-size(l);
                        text-transform: uppercase;
                        text-align: center;
                    }
                }
            }
        }
    }

    .switch {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-left: 16px;

        .switch-label {
            position: relative;
            display: inline-block;
            width: 40px;
            height: 20px;

            input {
                opacity: 0;
                width: 0;
                height: 0;

                &:checked + .slider {
                    background-color: $main;
                }

                &:checked + .slider:before {
                    transform: translateX(20px);
                }
            }

            .slider {
                position: absolute;
                cursor: pointer;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: #ccc;
                transition: 0.4s;
                border-radius: 20px;

                &:before {
                    position: absolute;
                    content: '';
                    height: 16px;
                    width: 16px;
                    left: 2px;
                    bottom: 2px;
                    background-color: white;
                    transition: 0.4s;
                    border-radius: 50%;
                }
            }
        }

        .switch-text {
            font-family: $text;
            @include font-size(s);
            color: $color-neutral-600;
        }
    }
}

//RBI DEVICE
@media (max-width: 1285px) {
    .table {
        .topbar {
            .navBar {
                .nav-elements {
                    .timeframe {
                        .title {
                            @include font-size(sm);
                        }
                        .description {
                            @include font-size(xs);
                        }
                    }
                    .printer {
                        width: 40px;
                        height: 40px;
                    }
                }
            }
        }
    }
}
</style>
